import { connect } from 'react-redux';
import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectIaLogic } from 'selectors/general';
import Schedules from './Schedules';

function mapStateToProps(state, ownProps) {
  const { children } = ownProps;
  const { isManualStudio, isMsInventoryVenue } = selectActiveVenue(state);
  const { userHasAccess: canViewClasstivityScheduler } = selectIaLogic(state, IA_KEY.CLASSTIVITY_SCHEDULER);

  return {
    isManualStudio,
    isMsInventoryVenue,
    canViewClasstivityScheduler,
    children,
  };
}

export default connect(mapStateToProps)(Schedules);
